export default __webpack_public_path__ + "static/media/cardLname_info.a82f4bed.png";